import { render, staticRenderFns } from "./OSSFileUploader.vue?vue&type=template&id=732c99d7&scoped=true"
import script from "./OSSFileUploader.vue?vue&type=script&lang=js"
export * from "./OSSFileUploader.vue?vue&type=script&lang=js"
import style0 from "./OSSFileUploader.vue?vue&type=style&index=0&id=732c99d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c99d7",
  null
  
)

export default component.exports